<template>
  <b-col cols="6">
    <b-row>
      <b-col :cols="showJurusan ? 6 : 12">
        <b-form-group
          label="Jenjang Pendidikan"
          description="Filter data berdasarkan Jenjang Pendidikan"
        >
          <v-select
            :value="filter.jenjang_pendidikan_id"
            :options="lists.jenjang"
            label="text"
            :reduce="(item) => item.value"
            placeholder="-- Pilih Jenjang --"
            @input="onJenjang"
          ></v-select>
        </b-form-group>
      </b-col>
      <b-col v-if="showJurusan" cols="6">
        <b-form-group label="Jurusan" description="Filter data berdasarkan Jurusan">
          <v-select
            :value="filter.jurusan_id"
            :options="lists.jurusan"
            label="text"
            :reduce="(item) => item.value"
            placeholder="-- Pilih Jurusan --"
            @input="onJurusan"
          ></v-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import 'vue-select/dist/vue-select.css'
export default {
  name: 'HelperJenjangJurusanFilter',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    institutionId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      lists: {
        jenjang: [],
        jurusan: [],
      },
      needJurusan: false,
      jumlahTingkat: 0,
      orderBy: 0,
      tingkatAwal: 0,
      tingkatAkhir: 0,
      isLetterLabel: false,
    }
  },
  computed: {
    realInstitutionId() {
      return this.institutionId && this.institutionId !== 'all' ? this.institutionId : ''
    },
    showJurusan() {
      return !!(this.realInstitutionId && this.needJurusan)
    },
  },
  watch: {
    realInstitutionId() {
      this.reloadByInstitution()
    },
  },
  mounted() {
    this.reloadByInstitution()
  },
  methods: {
    selectedJenjang() {
      const id = this.filter.jenjang_pendidikan_id
      if (!id) return null
      return this.lists.jenjang.find((j) => j.value === id) || null
    },
    applyJenjangMeta(opt) {
      this.needJurusan = !!(opt && opt.is_need_jurusan)
      this.jumlahTingkat = (opt && opt.jumlah_tingkat) || 0
      this.orderBy = Number((opt && opt.order_by) || 0)
      this.tingkatAwal = Number((opt && opt.tingkat_awal) || 0)
      this.tingkatAkhir = Number((opt && opt.tingkat_akhir) || 0)
      this.isLetterLabel = !!(opt && opt.is_letter_label) || this.orderBy === 0
      if (!this.needJurusan) {
        this.$set(this.filter, 'jurusan_id', '')
        this.lists.jurusan = []
      }
    },
    emitMeta() {
      this.$emit('change', this.filter)
      this.$emit('meta', {
        jumlah_tingkat: this.jumlahTingkat,
        order_by: this.orderBy,
        tingkat_awal: this.tingkatAwal,
        tingkat_akhir: this.tingkatAkhir,
        is_letter_label: this.isLetterLabel,
        is_need_jurusan: this.needJurusan,
        jenjang_pendidikan_id: this.filter.jenjang_pendidikan_id || '',
      })
    },
    async reloadByInstitution() {
      this.$set(this.filter, 'jurusan_id', '')
      this.lists.jurusan = []
      this.needJurusan = false
      this.jumlahTingkat = 0
      this.orderBy = 0
      this.tingkatAwal = 0
      this.tingkatAkhir = 0
      this.isLetterLabel = false

      if (this.realInstitutionId) {
        await this.loadJenjangFromLembaga()
      } else {
        this.$set(this.filter, 'jenjang_pendidikan_id', '')
        await this.loadAllJenjang()
      }

      if (this.showJurusan) {
        await this.loadJurusan()
      }
      this.emitMeta()
    },
    async loadJenjangFromLembaga() {
      try {
        const res = await this.$axios.get(
          `/api/admin/options/jenjang-lembaga?institution_id=${this.realInstitutionId}`
        )
        const info = res.data?.data || {}
        if (info.jenjang_pendidikan_id) {
          const opt = {
            value: info.jenjang_pendidikan_id,
            text: info.jenjang_pendidikan_name || 'Jenjang Lembaga',
            is_need_jurusan: !!info.is_need_jurusan,
            jumlah_tingkat: info.jumlah_tingkat || 0,
            order_by: info.order_by || 0,
            tingkat_awal: info.tingkat_awal || 0,
            tingkat_akhir: info.tingkat_akhir || 0,
            is_letter_label: !!info.is_letter_label,
          }
          this.lists.jenjang = [opt]
          this.$set(this.filter, 'jenjang_pendidikan_id', opt.value)
          this.applyJenjangMeta(opt)
        } else {
          this.lists.jenjang = []
          this.$set(this.filter, 'jenjang_pendidikan_id', '')
          this.applyJenjangMeta(null)
        }
      } catch (e) {
        this.lists.jenjang = []
        this.$set(this.filter, 'jenjang_pendidikan_id', '')
        this.applyJenjangMeta(null)
      }
    },
    async loadAllJenjang() {
      try {
        const res = await this.$axios.get('/api/admin/options/jenjang-pendidikan')
        this.lists.jenjang = res.data.data || []
      } catch (e) {
        this.lists.jenjang = []
      }
      this.applyJenjangMeta(this.selectedJenjang())
    },
    async loadJurusan() {
      if (!this.realInstitutionId || !this.needJurusan) {
        this.lists.jurusan = []
        return
      }
      try {
        const res = await this.$axios.get(
          `/api/admin/options/jurusan?institution_id=${this.realInstitutionId}`
        )
        this.lists.jurusan = res.data.data || []
      } catch (e) {
        this.lists.jurusan = []
      }
    },
    async onJenjang(val) {
      this.$set(this.filter, 'jenjang_pendidikan_id', val || '')
      this.$set(this.filter, 'jurusan_id', '')
      this.applyJenjangMeta(this.selectedJenjang())
      if (this.showJurusan) {
        await this.loadJurusan()
      } else {
        this.lists.jurusan = []
      }
      this.emitMeta()
    },
    onJurusan(val) {
      this.$set(this.filter, 'jurusan_id', val || '')
      this.emitMeta()
    },
  },
}
</script>
